
export class SupportAssistContext {
    constructor() {

    }
}
